
import React, { useState, useEffect, useRef } from 'react'
import { PullToRefresh, ListView } from 'antd-mobile';
import Loading from '@/components/Loading'
import styled from 'styled-components';

const ListViewContainer = styled.div`
  .am-list-body::before ,.am-list-body::after {
    height: 0!important;
  }
  .am-list-view-scrollview::-webkit-scrollbar{
    display: none;
  }
  .am-list-body{
    background: transparent;
  }
  .am-pull-to-refresh-content-wrapper {
    min-height: calc(100vh - 80px);
  }
`
export default ({ content = [], renderRow, OnRefresh,OnEndReached, refreshing , isLoading, endText ,type}) => {
  const [useBodyScroll] = useState(true)
  const [dataSource, setdataSource] = useState(new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2,
  }))
  const [height, setheight] = useState(document.documentElement.clientHeight)
  const lvRef =useRef()
  const onRefresh = () => {
    OnRefresh&& OnRefresh()
  };

  const onEndReached = (event) => {
    OnEndReached && OnEndReached(event)
  };

  const separator = (sectionID, rowID) => (
    <div
      key={`${sectionID}-${rowID}`}
      style={{
        'margin-bottom': '10px'
      }}
    />
  );
  useEffect(() => {
    if(content.length> 0){
      setdataSource(dataSource.cloneWithRows(content))
    }
  }, [content])
  useEffect(() => {
    if (useBodyScroll) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [useBodyScroll])
  useEffect(() => {
    setheight(height- lvRef.current.offsetTop)
  }, [height])
  return (
    <ListViewContainer >
      <ListView
        key={useBodyScroll ? '0' : '1'}
        ref={lvRef}
        dataSource={dataSource}
        renderFooter={() => (<div style={{ padding: 20, textAlign: 'center' }}>
          {isLoading ? <Loading /> : endText}
        </div>)}
        renderRow={renderRow}
        renderSeparator={separator}
        useBodyScroll={useBodyScroll}
        style={useBodyScroll ? {} : {
          height: height,
          margin: '5px 0',
        }}
        pullToRefresh={<PullToRefresh
          refreshing={refreshing}
          onRefresh={onRefresh}
          indicator={{ release: <Loading /> }}
        />}
        scrollRenderAheadDistance={500}
        onEndReachedThreshold={10}
        onEndReached={()=>onEndReached()}
        pageSize={10}
      />
    </ListViewContainer>)
}


// WEBPACK FOOTER //
// ./src/components/ListView/index.js